import { z } from 'zod';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { SaleType } from 'modules/desking';
import { SendVia, SendEmailOption, EmailOptionGroups } from '../types';

export const contactsStepSchema = z.object({
  ownerPgIds: z.array(z.string()),
  accountContactIds: z.array(z.string()),
});

// Aggregate-only placeholder until the Equipment step's real fields are defined
export const equipmentStepSchema = z.object({
  selectedId: z.string().nullable(),
});

// Aggregate-only placeholder until the Pricing step's real fields are defined
export const pricingStepSchema = z.object({
  lineItems: z.array(z.record(z.string(), z.unknown())),
  customerDeposit: z.object({
    type: z.nativeEnum(QuoteDepositType),
    value: z.number(),
    notes: z.string(),
  }),
});

export const financeMenuStepSchema = z.object({
  isEnabled: z.boolean(),
  saleType: z.nativeEnum(SaleType),
});

const sendEmailOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
  fullName: z.string(),
  email: z.string().email(),
  title: z.string(),
  group: z.nativeEnum(EmailOptionGroups),
});

export const reviewSendStepSchema = z.object({
  notesToBuyer: z.string().nullable(),
  sendVia: z.nativeEnum(SendVia),
  sendEmailTo: sendEmailOptionSchema.array().optional(),
  ccEmails: sendEmailOptionSchema.array().optional(),
});

export const dealBuilderFormSchema = z.object({
  contacts: contactsStepSchema,
  equipment: equipmentStepSchema,
  pricing: pricingStepSchema,
  financeMenu: financeMenuStepSchema,
  reviewSend: reviewSendStepSchema,
});
